// extracted by mini-css-extract-plugin
export default {"wrapper":"_o-z","response":"ap-z","error":"bp-z","disabled":"cp-z","buttons":"dp-z","feedbackQuestionSection":"ep-z","yesNoWrapper":"fp-z"};